import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { Button, Grid } from "@mui/material";
import ReceiptForm from "./Forms/ReceiptForm";
import useStyles from "../../../../styles/styles";
import { configState } from "../../../../recoil/atoms";
import { CreateReceiptBody, ReceiptApi } from "../../../../api/payment";
import { ReceiptsValidationSchema } from "./FormModel/validationSchema";

type Props = {
  patientID?: string;
};

const AddPatientReceipts = ({ patientID }: Props) => {
  const config = useRecoilValue(configState);
  const classes = useStyles();

  const addPatientReceipt = (values: CreateReceiptBody, actions: any) => {
    const patientReceipt = new ReceiptApi(config);
    patientReceipt
      .createReceipt(values)
      .then((res) => {
        toast.success("Receipt added successfully!");
        actions.resetForm({});
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const handleSubmit = (values: CreateReceiptBody, actions: any) => {
    actions.setTouched({});
    actions.setSubmitting(false);
    addPatientReceipt({ ...values }, actions);
  };

  return (
    <>
      <Formik
        initialValues={{
          patient_id: patientID!,
          amount: 0,
          currency: "",
        }}
        enableReinitialize={true}
        validationSchema={ReceiptsValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ dirty, isSubmitting, values }) => {          
          return (
            <Form>
              <ReceiptForm isEditing={false}/>
              <Grid className={classes.buttons}>
                <Grid className={classes.wrapper}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    disabled={isSubmitting}
                  >
                    Add Receipt
                  </Button>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddPatientReceipts;
